import { useCallback } from "react";
import useAxios from "@libs/axios/useAxios";
import {
  AD_LIST_URL,
  BRAND_EXPLORE,
  BRAND_SORT_URL,
  BRAND_URL,
  GET_BRAND_URL,
  GET_CART_URL,
  GET_CATEGORY_URL,
  GET_COLOR_URL,
  GET_CONDITION_URL,
  GET_FAQ_CATEGORY_URL,
  GET_FAQ_LIST_URL,
  GET_FOLLOW_URL,
  GET_NEWS_LIST_URL,
  GET_PRODUCT_DETAIL_URL,
  GET_SIZE_URL,
  GET_USER_INFO_URL,
  NEW_IN_URL,
  POST_CART_URL,
  POPUP_URL,
  POST_PRODUCT_URL,
  PROMOTION_URL,
  PURCHASE_QNA_LIST,
  SALES_QNA_LIST,
  SELLER_URL,
  WE_LOVES_URL,
  CHECK_DUPLICATE_NICKNAME,
  GET_PRODUCT_URL,
  PRODUCT_QNA_LIST,
  SEARCH_BRAND_LIST,
  SEARCH_SELLER_LIST,
  EMAIL_VERIFICATION_URL,
  GET_EMAIL_VERIFICATION_URL,
  MEMBER_URL,
  GET_GENDER_LIST_URL,
  SIGN_IN_URL,
  POST_ORDER_URL,
  PATCH_CART_URL,
  DELETE_CART_URL,
  DELETE_ORDER_URL,
  GET_ORDER_LIST_URL,
  GET_ORDER_SORT_LIST_URL,
  GET_ORDER_DETAIL_URL,
  UPDATE_ORDER_URL,
  GET_ORDER_STATUS_URL,
  REVIEW_URL,
  PRODUCT_DATA_FOR_REVIEW_URL,
  GET_RECEIVED_REVIEW_URL,
  PATCH_PRODUCT_URL,
  GET_SALES_LIST_URL,
  GET_SALES_SORT_LIST_URL,
  UPDATE_PRODUCT_STATUS_URL,
  DELETE_PRODUCT_URL,
  GET_SHIPPING_ADDRESS,
  PATCH_SHIPPING_ADDRESS,
  GET_SALES_DETAIL_URL,
  CONFIRM_ORDER_URL,
  PRODUCT_POPUP_URL,
  BANK_LIST_URL,
  UPDATE_BILLING_KEY_URL,
  ADD_MEMBER_SUBSCRIPTION_URL,
  GET_MEMBER_SUBSCRIPTION_STATUS,
  PATCH_MEMBER_SUBSCRIPTION_CANCEL_URL,
  PATCH_PASSWORD_URL,
  GET_PRODUCT_SORT_URL,
  GET_ACTIVITY_ALARM_URL,
  CONFIRM_PAYMENT_URL,
  FIND_PASSWORD_EMAIL_VERIFICATION_URL,
  GET_FIND_PASSWORD_EMAIL_VERIFICATION_URL,
  FIND_PASSWORD_URL,
  DEACTIVATE_URL,
  GET_HOME_SELLER_LIST_URL,
  PATCH_NOTIFICATION_READ_STATUS_URL,
  COPY_PRODUCT_URL,
  GET_NOTIFICATION_STATUS_URL,
  PATCH_NOTIFICATION_STATUS_URL,
  CHECK_EMAIL_URL,
  SUBSCRIPTION_PAYMENT_LIST_URL,
  PRODUCT_CHARGE_RATE_URL,
  EVENT_URL,
  HAS_REVIEW_URL,
  COUNTRY_URL,
  EXCHANGE_URL,
} from "@libs/apiUrl";
import axios from "axios";

export const useApiRequest = () => {
  const { axiosInstance } = useAxios();

  //COLOR LIST
  const getColorList = useCallback(async () => {
    const res = await axiosInstance.get(GET_COLOR_URL);

    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);

  //SIZE LIST
  const getSizeList = useCallback(async (sizeTypeId: number) => {
    const res = await axios.get(`${GET_SIZE_URL}?size_type_id=${sizeTypeId}`);

    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  //유저 정보
  const getUserInfo = useCallback(async () => {
    const res = await axiosInstance.get(GET_USER_INFO_URL);

    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);

  //셀러 정보
  const getSellerInfo = useCallback(
    async (sellerId: number) => {
      const res = await axiosInstance.get(`${SELLER_URL}/${sellerId}`);

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  //컨디션 리스트
  const getConditionList = useCallback(async () => {
    const res = await axiosInstance.get(GET_CONDITION_URL);

    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);

  //브랜드 리스트
  const getBrandList = useCallback(async () => {
    const res = await axiosInstance.get(GET_BRAND_URL);

    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);

  //브랜드 정렬 리스트
  const getBrandSortList = useCallback(async () => {
    const res = await axiosInstance.get(BRAND_SORT_URL);

    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);

  //카테고리 리스트
  const getCategoryList = useCallback(
    async (parentId?: number | null) => {
      const url = parentId
        ? `${GET_CATEGORY_URL}?parent_id=${parentId}`
        : GET_CATEGORY_URL;

      try {
        const res = await axiosInstance.get(url);

        if (res.status === 200) {
          return res.data.data;
        }
      } catch (error) {
        console.error("카테고리 목록을 가져오는 중 에러 발생:", error);
      }
    },
    [axiosInstance],
  );

  //상품 상세정보
  const getProductDetail = useCallback(
    async (productId: number) => {
      const res = await axiosInstance.get(
        `${GET_PRODUCT_DETAIL_URL}/${productId}`,
      );

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  //Size with stock
  const getSizeWithStock = useCallback(
    async (productId: number, colorId: number | null) => {
      const res = await axiosInstance.get(
        `${GET_PRODUCT_DETAIL_URL}/${productId}/${colorId}/size`,
      );

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  //팔로우 카운트
  const getFollowCnt = useCallback(
    async (userId: number) => {
      const res = await axiosInstance.get(
        `api/v1/seller/${userId}/follow/count`,
      );

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  //팔로워 리스트
  const getFollowerList = useCallback(
    async (userId: number | undefined) => {
      const res = await axiosInstance.get(
        `${GET_FOLLOW_URL}/${userId}/follower`,
      );

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  //팔로잉 리스트
  const getFollowingList = useCallback(
    async (userId: number | undefined) => {
      const res = await axiosInstance.get(
        `${GET_FOLLOW_URL}/${userId}/following`,
      );

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  //팔로우 팔로잉 패치
  const patchFollow = useCallback(
    async (userId: number | undefined) => {
      const res = await axiosInstance.patch(
        `${GET_FOLLOW_URL}/${userId}/follow`,
      );

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  //브랜드 좋아요
  const patchBrandLike = useCallback(
    async (brandId: number) => {
      const res = await axiosInstance.patch(`${BRAND_URL}/${brandId}/like`);

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  //상품 좋아요
  const patchProductLike = useCallback(
    async (productId: number) => {
      const res = await axiosInstance.patch(
        `${POST_PRODUCT_URL}/${productId}/like`,
      );

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  //셀러 follow count 조회
  const getSellerFollowCount = useCallback(
    async (sellerId: number) => {
      const res = await axiosInstance.get(
        `${SELLER_URL}/${sellerId}/follow/count`,
      );

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  //We Loves 상품 리스트
  const getWeLovesList = useCallback(async (categoryId: number) => {
    const res = await axios.get(`${WE_LOVES_URL}?category_id=${categoryId}`);

    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  //도매 브랜드 탐험
  const getBrandExploreList = useCallback(async () => {
    const res = await axios.get(BRAND_EXPLORE);

    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // post cart
  const postCart = useCallback(async (cartData: any) => {
    const res = await axiosInstance.post(POST_CART_URL, cartData);

    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // get cart
  const getCart = useCallback(async () => {
    const res = await axiosInstance.get(GET_CART_URL);

    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  //로그인 팝업 이미지
  const getPopup = useCallback(async () => {
    const res = await axios.get(POPUP_URL);

    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // 홈 프로모션 리스트
  const getPromotionList = useCallback(async (categoryId: number) => {
    const res = await axios.get(`${PROMOTION_URL}?category_id=${categoryId}`);

    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // 홈 AD 리스트
  const getAdList = useCallback(async () => {
    const res = await axios.get(`${AD_LIST_URL}`);

    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // 홈 취향저격 셀러 리스트
  const getHomeSellerList = useCallback(async () => {
    const res = await axios.get(GET_HOME_SELLER_LIST_URL);

    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  //FAQ 카테고리
  const getFaqCategory = useCallback(async () => {
    const res = await axios.get(GET_FAQ_CATEGORY_URL);

    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // FAQ 리스트
  const getFaqList = useCallback(
    async (category: string) => {
      const res = await axiosInstance.get(
        `${GET_FAQ_LIST_URL}?category=${category}`,
      );

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  // NEWS 리스트
  const getNewsList = useCallback(async () => {
    const res = await axiosInstance.get(`${GET_NEWS_LIST_URL}`);

    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);

  // 활동 알림 리스트
  const getActivityAlarmList = useCallback(async () => {
    const res = await axiosInstance.get(`${GET_ACTIVITY_ALARM_URL}`);

    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);

  // NEWS Detail
  const getNewsDetail = useCallback(
    async (newsId: number) => {
      const res = await axiosInstance.get(`${GET_NEWS_LIST_URL}/${newsId}`);

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  // 구매 문의 LIST
  const getPurchaseQnaList = useCallback(async () => {
    const res = await axiosInstance.get(`${PURCHASE_QNA_LIST}`);

    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);

  // 판매 문의 LIST
  const getSalesQnaList = useCallback(async () => {
    const res = await axiosInstance.get(`${SALES_QNA_LIST}`);

    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);

  // 상품 문의 LIST
  const getProductQnaList = useCallback(
    async (productId: number) => {
      const res = await axiosInstance.get(
        `${GET_PRODUCT_URL}/${productId}/qna`,
      );

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  // 상품 문의 LIST
  const getProductQnaAnswerList = useCallback(
    async (qnaId: number) => {
      const res = await axiosInstance.get(
        `${PRODUCT_QNA_LIST}/${qnaId}/answer`,
      );

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  // 브랜드 검색 LIST
  const getSearchBrandList = useCallback(
    async (value: string) => {
      const res = await axiosInstance.get(
        `${SEARCH_BRAND_LIST}?search_value=${value}`,
      );

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  // 셀러 검색 LIST
  const getSearchSellerList = useCallback(
    async (value: string) => {
      const res = await axiosInstance.get(
        `${SEARCH_SELLER_LIST}?search_value=${value}`,
      );

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  // 셀러 검색 LIST
  const getBrandDetail = useCallback(
    async (brandId: number) => {
      const res = await axiosInstance.get(`${BRAND_URL}/${brandId}`);

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  // 닉네임 중복체크
  const getNicknameCheck = useCallback(
    async (nickName: string) => {
      const res = await axiosInstance.get(
        `${CHECK_DUPLICATE_NICKNAME}/${nickName}`,
      );
      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  // POST 인증링크 전송
  const postVerifyEmail = useCallback(
    async (login_id: string, language: string) => {
      const res = await axios.post(EMAIL_VERIFICATION_URL, {
        email: login_id,
        language: language,
      });

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [],
  );

  // 비밀번호찾기 이메일 인증하기
  const postFindPasswordEmail = useCallback(
    async (login_id: string, language: string) => {
      const res = await axios.post(FIND_PASSWORD_EMAIL_VERIFICATION_URL, {
        email: login_id,
        language: language,
      });
      if (res.status === 200) {
        return res.data.data;
      }
    },
    [],
  );

  // GET 이메일 인증하기
  const getVerifyEmail = useCallback(async (verification_code: string) => {
    const res = await axios.get(
      `${GET_EMAIL_VERIFICATION_URL}?verification_code=${verification_code}`,
    );
    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // 비밀번호 찾기 인증
  const getFindPassword = useCallback(async (verification_code: string) => {
    const res = await axios.get(
      `${GET_FIND_PASSWORD_EMAIL_VERIFICATION_URL}?verification_code=${verification_code}`,
    );
    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  const getGenderList = useCallback(async () => {
    const res = await axios.get(GET_GENDER_LIST_URL);
    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // 프로필 데이터 업데이트
  const patchProfile = useCallback(async (data: any) => {
    const res = await axiosInstance.patch(MEMBER_URL, data);
    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  const postLogin = useCallback(async (data: any) => {
    const res = await axios.post(SIGN_IN_URL, data);
    if (res.status === 200) {
      return res;
    }
  }, []);

  const postPayment = useCallback(async (data: any) => {
    const res = await axiosInstance.post(POST_ORDER_URL, data);
    if (res.status === 200) {
      
      return res.data.data;
    }
  }, []);

  const deletePayment = useCallback(async (id: any) => {
    const res = await axiosInstance.delete(`${DELETE_ORDER_URL}/${id}`);
    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // 결제 승인 요청
  const postPaymentConfirm = useCallback(
    async (id: any, amount: number, payment_key: string, method: string) => {
      const res = await axiosInstance.post(
        `${CONFIRM_PAYMENT_URL}/${id}/payment/confirm`,
        {
          amount: Number(amount),
          payment_key: payment_key,
          payment_method: method,
        },
      );
      if (res.status === 200) {
        return res.data.data;
      }
    },
    [],
  );

  const patchCartAmount = useCallback(
    async ({ id, amount }: { id: number; amount: number }) => {
      const res = await axiosInstance.patch(`${PATCH_CART_URL}/${id}/amount`, {
        amount: amount,
      });
      if (res.status === 200) {
        return res.data.data;
      }
    },
    [],
  );

  const deleteCart = useCallback(async (cart_id_list: number[]) => {
    const res = await axiosInstance.delete(DELETE_CART_URL, {
      data: { cart_id_list },
    });
    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // 주문리스트
  const getOrderList = useCallback(async (order_status?: string) => {
    const url = order_status
      ? `${GET_ORDER_LIST_URL}?order_status=${order_status}`
      : GET_ORDER_LIST_URL;

    const res = await axiosInstance.get(url);
    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // 주문 상태 정렬 리스트
  const getOrderSortList = useCallback(async () => {
    const res = await axiosInstance.get(GET_ORDER_SORT_LIST_URL);
    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // 판매 상태 정렬 리스트
  const getSalesSortList = useCallback(async () => {
    const res = await axiosInstance.get(GET_SALES_SORT_LIST_URL);
    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // 주문 상세
  const getOrderDetail = useCallback(async (order_id: number) => {
    const res = await axiosInstance.get(`${GET_ORDER_DETAIL_URL}/${order_id}`);
    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // 판매리스트
  const getSalesList = useCallback(async (order_status?: string) => {
    const url = order_status
      ? `${GET_SALES_LIST_URL}?order_status=${order_status}`
      : GET_SALES_LIST_URL;

    const res = await axiosInstance.get(url);
    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // 판매 리스트 상세
  const getSalesDetail = useCallback(async (order_id: number) => {
    const res = await axiosInstance.get(
      `${GET_SALES_DETAIL_URL}/${order_id}/sales`,
    );
    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // 결제수단 업데이트
  const updateOrder = useCallback(async (id: number, payment: string, lang: string) => {
    const res = await axiosInstance.patch(`${UPDATE_ORDER_URL}/${id}/payment`, {
      payment_method: payment,
      notification_language: lang
    });
    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // 구매확정 업데이트
  const updateOrderConfirm = useCallback(
    async (order_id: number, seller_id: number, lang: any) => {
      const res = await axiosInstance.patch(
        `${CONFIRM_ORDER_URL}/${order_id}/seller/${seller_id}/confirm`,{
          notification_language: lang
        }
      );
      if (res.status === 200) {
        return res.data.data;
      }
    },
    [],
  );

  // 발송완료 업데이트
  const updateOrderShip = useCallback(
    async (order_id: number, seller_id: number) => {
      const res = await axiosInstance.patch(
        `${CONFIRM_ORDER_URL}/${order_id}/seller/${seller_id}/ship`,
      );
      if (res.status === 200) {
        return res.data.data;
      }
    },
    [],
  );

  // 리뷰 작성
  const postReview = useCallback(async (postData: any) => {
    const res = await axiosInstance.post(REVIEW_URL, postData);
    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // 리뷰 작성여부 조회
  const getHasReview = useCallback(
    async (order_id: number, seller_id: number) => {
      const res = await axiosInstance.get(
        `${HAS_REVIEW_URL}/${order_id}/seller/${seller_id}/hasReview`,
      );

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  const getProductDataForReview = useCallback(
    async (orderId: number, orderSellerId: number) => {
      const res = await axiosInstance.get(
        `${PRODUCT_DATA_FOR_REVIEW_URL}/order/${orderId}/seller/${orderSellerId}/product`,
      );
      if (res.status === 200) {
        return res.data.data;
      }
    },
    [],
  );

  //받은 리뷰
  const getReceivedReviewList = useCallback(async (sellerId: number) => {
    const res = await axiosInstance.get(
      `${GET_RECEIVED_REVIEW_URL}/${sellerId}`,
    );
    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  //내가 쓴 리뷰
  const getMyReviewList = useCallback(async () => {
    const res = await axiosInstance.get(`${REVIEW_URL}`);
    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // 상품 비활성화
  const updateProductStatus = useCallback(
    async (id: number, status: string) => {
      const res = await axiosInstance.patch(
        `${UPDATE_PRODUCT_STATUS_URL}/${id}/status`,
        {
          is_active: status,
        },
      );
      if (res.status === 200) {
        return res.data.data;
      }
    },
    [],
  );

  // 상품 삭제
  const deleteProduct = useCallback(async (id: number) => {
    const res = await axiosInstance.delete(`${DELETE_PRODUCT_URL}/${id}`);
    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // 배송지 가져오기
  const getDeliveryList = useCallback(async () => {
    const res = await axiosInstance.get(GET_SHIPPING_ADDRESS);
    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // 배송지 수정하기
  const updateDelivery = useCallback(async (postData: any) => {
    const res = await axiosInstance.patch(PATCH_SHIPPING_ADDRESS, postData);
    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  const getProductPopup = useCallback(async () => {
    const res = await axiosInstance.get(`${PRODUCT_POPUP_URL}`);
    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // 상품 수정
  const updateProduct = useCallback(
    async (productId: number, data: any) => {
      const res = await axiosInstance.patch(
        `${PATCH_PRODUCT_URL}/${productId}`,
        data,
      );

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  //은행 목록
  const getBankList = async () => {
    const res = await axios.get(`${BANK_LIST_URL}`);
    if (res.status === 200) {
      return res.data.data;
    }
  };

  // 구독 빌링 키 업데이트
  const patchBillingKey = useCallback(
    async (data: any) => {
      const res = await axiosInstance.patch(UPDATE_BILLING_KEY_URL, data);

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  // 구독 post
  const postAddMemberSubscription = useCallback(
    async (data: any) => {
      const res = await axiosInstance.post(ADD_MEMBER_SUBSCRIPTION_URL, data);

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  // 구독 상태
  const getMemberSubscription = useCallback(async () => {
    const res = await axiosInstance.get(GET_MEMBER_SUBSCRIPTION_STATUS);

    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);

  // 구독 취소
  const patchMemberSubscription = useCallback(async () => {
    const res = await axiosInstance.patch(PATCH_MEMBER_SUBSCRIPTION_CANCEL_URL);

    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);

  // 비밀번호 변경
  const patchChangePassword = useCallback(
    async (data: any) => {
      const res = await axiosInstance.patch(PATCH_PASSWORD_URL, data);

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  // 비밀번호 찾기 변경
  const patchFindPassword = useCallback(
    async (data: any) => {
      const res = await axiosInstance.patch(FIND_PASSWORD_URL, data);

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  // 상품 정렬
  const getProductSort = useCallback(async () => {
    const res = await axiosInstance.get(GET_PRODUCT_SORT_URL);

    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);

  // 탈퇴하기
  const patchDeactivate = useCallback(async () => {
    const res = await axiosInstance.patch(DEACTIVATE_URL);

    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);

  // 알림 상태 업데이트
  const patchNotification = useCallback(
    async (id: number) => {
      const res = await axiosInstance.patch(
        `${PATCH_NOTIFICATION_READ_STATUS_URL}/${id}/read`,
      );

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  // 상품 복사하기
  const postCopyProduct = useCallback(
    async (id: number) => {
      const res = await axiosInstance.post(`${COPY_PRODUCT_URL}/${id}/copy`);

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  // 유저 알람 상태 조회
  const getNotification = useCallback(async () => {
    const res = await axiosInstance.get(GET_NOTIFICATION_STATUS_URL);

    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);

  // 유저 알람 상태 업데이트
  const patchNotificationStatus = useCallback(
    async (data: any) => {
      const res = await axiosInstance.patch(
        PATCH_NOTIFICATION_STATUS_URL,
        data,
      );

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  // 이메일 체크
  const getCheckEmail = useCallback(async (email: any) => {
    const res = await axios.get(
      `${CHECK_EMAIL_URL}/check-exists?email=${email}`,
    );

    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // 구독내역 리스트
  const getSubscriptionList = useCallback(async () => {
    const res = await axiosInstance.get(SUBSCRIPTION_PAYMENT_LIST_URL);

    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);

  // 상품 요율 조회
  const getProductRate = useCallback(async () => {
    const res = await axiosInstance.get(PRODUCT_CHARGE_RATE_URL);

    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);

  // 이벤트 상세조회
  const getEventDetail = useCallback(
    async (promotionId: number) => {
      const res = await axiosInstance.get(`${EVENT_URL}/${promotionId}`);

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  // 이벤트 상품 목록 조회
  const getEventProductList = useCallback(
    async (promotionId: number) => {
      const res = await axiosInstance.get(
        `${EVENT_URL}/${promotionId}/product`,
      );

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  // 국가
  const getCountry = useCallback(async () => {
    const res = await axios.get(`${COUNTRY_URL}`);

    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  //환율 적용
  const getExchange = useCallback(
    async (totalPrice: number) => {
      const res = await axiosInstance.get(EXCHANGE_URL, {
        params: { price: totalPrice },
      });

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );



  return {
    getColorList,
    getSizeList,
    getUserInfo,
    getConditionList,
    getCategoryList,
    getProductDetail,
    getSizeWithStock,
    getBrandList,
    getFollowCnt,
    getFollowerList,
    getFollowingList,
    patchFollow,
    getBrandSortList,
    patchBrandLike,
    getSellerInfo,
    getSellerFollowCount,
    patchProductLike,
    getWeLovesList,
    postCart,
    getCart,
    getBrandExploreList,
    getPopup,
    getPromotionList,
    getFaqCategory,
    getFaqList,
    getNewsList,
    getNewsDetail,
    getAdList,
    getPurchaseQnaList,
    getSalesQnaList,
    getProductQnaList,
    getProductQnaAnswerList,
    getSearchBrandList,
    getSearchSellerList,
    getBrandDetail,
    getNicknameCheck,
    postVerifyEmail,
    getVerifyEmail,
    getGenderList,
    patchProfile,
    postLogin,
    postPayment,
    deletePayment,
    patchCartAmount,
    deleteCart,
    getOrderList,
    getOrderSortList,
    getOrderDetail,
    updateOrder,
    updateOrderConfirm,
    postReview,
    getProductDataForReview,
    getReceivedReviewList,
    getMyReviewList,
    getSalesList,
    getSalesSortList,
    updateProductStatus,
    deleteProduct,
    postFindPasswordEmail,
    getDeliveryList,
    updateDelivery,
    getSalesDetail,
    updateOrderShip,
    getProductPopup,
    updateProduct,
    getBankList,
    patchBillingKey,
    postAddMemberSubscription,
    getMemberSubscription,
    patchMemberSubscription,
    patchChangePassword,
    getActivityAlarmList,
    getProductSort,
    postPaymentConfirm,
    getFindPassword,
    patchFindPassword,
    patchDeactivate,
    getHomeSellerList,
    patchNotification,
    postCopyProduct,
    getNotification,
    patchNotificationStatus,
    getCheckEmail,
    getSubscriptionList,
    getProductRate,
    getEventDetail,
    getEventProductList,
    getHasReview,
    getCountry,
    getExchange
  };
};
